import { useTranslation } from 'next-i18next';
import React from 'react';

import { removeToast } from '@/redux/slices/toast.slice';

import { useAppDispatch, useAppSelector } from '@/redux';
import { NS } from '@/constants';

import Toast from './Toast';

import styles from './ToastsContainer.module.scss';

export const ToastsContainer = (): React.JSX.Element => {
  const toastsMessages = useAppSelector(({ toast }) => toast.toastsMessages);
  const { t } = useTranslation(NS.COMMON);
  const dispatch = useAppDispatch();

  return (
    <div className={`${styles['toast-container']} row`}>
      {toastsMessages.map((toast) =>
        <Toast t={t} key={toast.id} toast={toast} onClose={() => dispatch(removeToast({ id: toast.id }))} />
      )}
    </div>
  );
};

export default ToastsContainer;
